import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";

import { apiClient } from "~/api/ApiClient";
import Spinner from "~/components/ui/spinner/Spinner";
import { useTeam } from "~/contexts/TeamProvider";
import { orderQueries } from "~/pages/services/queryKeys";

import { ordersTabFor, ordersTabPath } from "./ordersTab";

/**
 * Stripe's return_url after the embedded pay session (a full page load):
 * to the orders, telling OrderPaymentProvider to await the payment. On the
 * paid order's tab: the team's latest, since another order can't be placed
 * while one is pending. Link Building if it can't be told.
 */
const OrderPaymentReturn = () => {
  const { team } = useTeam();

  const { data: latestOrder, isPending } = useQuery({
    queryKey: orderQueries.latest(team?.id),
    queryFn: async () => {
      const response = await apiClient.billing.ordersList({
        type: "active",
        "page[size]": 1,
        "page[number]": 1,
        s: "created_at DESC",
      });

      return response.data?.["payments/orders"]?.[0] ?? null;
    },
    // Read once, on the way to the orders.
    gcTime: 0,
    retry: false,
  });

  if (isPending) return <Spinner />;

  return (
    <Navigate
      to={ordersTabPath(
        latestOrder ? ordersTabFor(latestOrder.service_type) : "links",
      )}
      state={{ afterOrderPayment: true }}
      replace
    />
  );
};

export default OrderPaymentReturn;
